export default __webpack_public_path__ + "static/media/hg-heart-logo.24da7cf9.png";